import { gql } from '@grandvisionhq/graphql';

const appliedDiscountFragment = gql`
  fragment AppliedDiscountFragment on DiscountPrice {
    appliedDiscounts {
      id
      type
      amount
      details {
        name {
          locale
          value
        }
        type
        value
      }
    }
  }
`;
const lineItemPrice = gql`
  fragment LineItemPriceFragment on LineItemPrice {
    total {
      discount {
        amount
        percentage
        __typename
        ...AppliedDiscountFragment
      }
      gross
      net
      subtotal
      tax {
        amount
        portions {
          amount
          rate
          __typename
        }
        __typename
      }
      __typename
    }
    unit {
      discount {
        amount
        percentage
        __typename
        ...AppliedDiscountFragment
      }
      gross
      net
      subtotal
      tax {
        amount
        portions {
          amount
          rate
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
  ${appliedDiscountFragment}
`;

export { appliedDiscountFragment, lineItemPrice };
//# sourceMappingURL=line-item-price.js.map
